import React from "react";

export default function DraftAnalysis() {
  return <div>DraftAnalysis</div>;
}
